// @ts-nocheck
import React, { PureComponent } from 'react'
import history from 'helpers/history'
import {
    getUpdatedList, handleRenderColumn, isValidDate,
} from 'helpers/methods/common'
import Status from 'types/status'
import OrderQuote from 'requests/objects/order-quote'
import styles from 'styles/pages/order-quotes/index.module.scss'
import { tKey, tObj } from 'helpers/methods/translate'
import {
    TextField, DefaultButton, DirectionalHint, TooltipDelay, TooltipHost, Text,
    Icon,
    ShimmeredDetailsList,
    ConstrainMode,
    SelectionMode, DetailsListLayoutMode,
} from '@fluentui/react'
import FilteredVirtualCombobox from 'components/inputs/filteredVirtualCombobox'
import { Columns } from 'react-bulma-components'
import parseJson from 'helpers/methods/parseJson'
import Card from 'components/containers/card'
import EProfile from 'types/users/enums/profile'
import MaintenancePortalInfo from 'components/pages/maintenancePortalInfo'
import time, { getLocaleFromLang } from 'helpers/methods/time'
import { NEW_PATH } from 'types/others'
import { Link } from 'react-router-dom'
import Pagination from 'components/pages/Pagination'
import flattenObj from 'helpers/methods/flattenObj'
import classNames from 'classnames'
import HandleBlob from 'helpers/methods/blob'
import CancelRequestError from 'requests/errors/cancelRequestError'
import UnauthorizedError from 'requests/errors/unauthorizedError'
import InvalidEntityError from 'requests/errors/invalidEntityError'
import NotImplementedError from 'requests/errors/notImplementedError'
import DatePicker from 'components/inputs/datePicker'

const DateFilterMinDate = new Date(1970, 0, 1)
const DateFilterMaxDate = new Date(2100, 11, 31)

/**
 * @typedef {object} SearchParamsType
 * @property {number[]} orderStatusIds orderStatusIds
 * @property {number[]} pickupAddressIds pickupAddressIds
 * @property {number[]} deliveryAddressIds deliveryAddressIds
 * @property {string} pickupAddress pickupAddress
 * @property {string} deliveryAddress deliveryAddress
 * @property {Date} creationDate creationDate
 * @property {Date} creationDateEnd creationDateEnd
 * @property {Date} deliveryDate deliveryDate
 * @property {Date} deliveryDateEnd deliveryDateEnd
 * @property {Date} pickupDate pickupDate
 * @property {Date} pickupDateEnd pickupDateEnd
 * @property {string} orderQuoteNumber orderQuoteNumber
 * @property {number[]} workflowStepIds workflowStepIds
 * @property {number} clientId clientId
 * @property {number} operatingCenterId operatingCenterId
 * @property {string} orderBy orderBy
 */

/** @debug {import('app').AppProps} */

/* eslint-disable jsdoc/check-values, jsdoc/check-tag-names */
/**
 * IndexOrderQuotes.
 *
 * @author Hassen MALEK
 * @version 1.1
 * @since 2026-02-02
 * @updated 2026-06-26
 * @augments {PureComponent<import('app').AppProps>}
 */
export default class IndexOrderQuotes extends PureComponent {
    /* eslint-enable jsdoc/check-values, jsdoc/check-tag-names */

    constructor(props) {
        super(props)

        this.state = {
            /** @type {Status} Current status of the component */
            status: Status.IDLE,
            /** @type {OrderQuote[]} Items found in API */
            items: [],
            /** @type {SearchParamsType} Params to search */
            searchParams: {
                orderStatusIds: [],
                pickupAddressIds: [],
                deliveryAddressIds: [],
                pickupAddress: '',
                deliveryAddress: '',
                creationDate: null,
                creationDateEnd: null,
                deliveryDate: null,
                deliveryDateEnd: null,
                pickupDate: null,
                pickupDateEnd: null,
                orderQuoteNumber: null,
                workflowStepIds: [],
                clientId: null,
                operatingCenterId: null,
                orderBy: null,
            },
            /** @type {import('@fluentui/react').IColumn[]} */
            orderQuoteColumns: [],
            /** @type {boolean} Is filter card reduced ? */
            isFilterCardReduced: true,
            pagination: {
                currentPage: 1,
                totalPages: 1,
                totalRecords: 0,
                recordsPerPage: 20,
            },
        }

        this.submitInput = React.createRef()
        this.toolTipRef = React.createRef()

        /** @type {NodeJS.Timeout} Time out to handle apply of searchParams */
        this.timeOutParams = null
    }

    /**
     * @inheritdoc
     */
    componentDidMount() {
        this.init()
    }

    /**
     * @inheritdoc
     * @param {object} prevProps Previous Props
     * @param {object} prevState Previous State
     */
    componentDidUpdate(prevProps, prevState) {
        const { lang, me, match } = this.props
        const { searchParams, pagination: { currentPage } } = this.state

        if (JSON.stringify(prevState.searchParams) !== JSON.stringify(searchParams)) {
            clearTimeout(this.timeOutParams)
            this.timeOutParams = setTimeout(() => {
                history.replace({ search: '' })
                this.syncSearchParamsInHistory()
            }, 250)
        } else if (lang !== prevProps.lang || me.companyId !== prevProps.me.companyId) {
            this.init()
        }

        if (prevState.pagination.currentPage !== currentPage)
            this.search()

        if (match.params?.key !== prevProps.match.params?.key)
            this.setState(
                state => ({ searchParams: { ...state.searchParams, workflowStepIds: [] } }),
                () => {
                    this.init()
                    this.search()
                },
            )
        if (prevState.searchParams.orderBy !== searchParams.orderBy)
            this.setColumns()
    }

    /**
     * @inheritdoc
     */
    componentWillUnmount() {
        this.orderQuotesHandlerGetAll?.cancel()
    }

    setColumns() {
        const { me, match, lang } = this.props
        const locale = getLocaleFromLang(lang)
        const { searchParams } = this.state
        const [sortedColumn = '', sortDirection = 'desc'] = (searchParams.orderBy || '').split('-')
        const isRefusedPage = match?.params?.key === 'refused'
        const isClientValidationPage = match?.params?.key === 'approved'

        const getNextSort = columnKey => (
            sortedColumn !== columnKey || sortDirection === 'desc'
                ? 'asc'
                : 'desc'
        )

        const cols = [
            {
                key: 'orderQuoteNumber',
                name: this.tKey('orderQuoteNumber'),
                minWidth: 100,
                maxWidth: 150,
                isResizable: true,
                className: styles['date-index-cell'],
                isSorted: sortedColumn === 'orderQuoteNumber',
                isSortedDescending: sortDirection === 'desc',
                onColumnClick: () => this.search(`orderQuoteNumber-${getNextSort('orderQuoteNumber')}`),
                onRender: row => row.orderQuoteNumber || '-',
            },

            {
                key: 'createdAt',
                name: this.tKey('createdThe'),
                fieldName: 'createdAt',
                minWidth: 60,
                maxWidth: 80,
                isResizable: true,
                className: styles['date-index-cell'],
                isSorted: sortedColumn === 'createdAt',
                isSortedDescending: sortDirection === 'desc',
                onColumnClick: () => this.search(`createdAt-${getNextSort('createdAt')}`),
                onRender:
                    // eslint-disable-next-line react/no-unstable-nested-components
                    orderQuote => (orderQuote.createdAt ? this.time(orderQuote.createdAt, { locale }).getCleanDate({
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                    }) : ''),
            },
            {
                key: 'pickupStartDate',
                name: this.tKey('pickupDate'),
                fieldName: 'pickupStartDate',
                minWidth: 100,
                maxWidth: 110,
                isResizable: true,
                className: styles['date-index-cell'],
                isSorted: sortedColumn === 'pickupDate',
                isSortedDescending: sortDirection === 'desc',
                onColumnClick: () => this.search(`pickupDate-${getNextSort('pickupDate')}`),

                onRender:
                    // eslint-disable-next-line react/no-unstable-nested-components
                    orderQuote => (orderQuote.pickupStartDate ? this.time(orderQuote.pickupStartDate, { locale }).getCleanDate({
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                    }) : ''),
            },
            {
                key: 'pickupAddress.label',
                name: this.tKey('pickupAddress'),
                fieldName: 'pickupAddress.label',
                minWidth: 120,
                maxWidth: 150,
                isResizable: true,
                onRender:
                    // eslint-disable-next-line react/no-unstable-nested-components
                    order => (
                        <div className={styles['address-cell']}>
                            <b>
                                {order['pickupAddress.label'] || ''}
                            </b>
                            <span>
                                {order['pickupAddress.street'] || ''}
                            </span>
                            <span>
                                {order['pickupAddress.zipCode'] || ''}
                                {' '}
                                {order['pickupAddress.city'] || ''}
                                {' '}
                                {order['pickupAddress.country.code'] || ''}
                            </span>
                        </div>
                    ),
            },
            {
                key: 'deliveryStartDate',
                name: this.tKey('deliveryStartDate'),
                fieldName: 'deliveryStartDate',
                minWidth: 100,
                maxWidth: 150,
                isResizable: true,
                className: styles['date-index-cell'],
                isSorted: sortedColumn === 'deliveryDate',
                isSortedDescending: sortDirection === 'desc',
                onColumnClick: () => this.search(`deliveryDate-${getNextSort('deliveryDate')}`),
                onRender: orderQuote => (orderQuote.deliveryStartDate
                    ? this.time(orderQuote.deliveryStartDate, { locale }).getCleanDate({
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                    })
                    : ''),
            },
            {
                key: 'deliveryEndDate',
                name: this.tKey('deliveryEndDate'),
                fieldName: 'Fin livraison',
                minWidth: 100,
                maxWidth: 150,
                isResizable: true,
                className: styles['date-index-cell'],
                isSorted: sortedColumn === 'deliveryEndDate',
                isSortedDescending: sortDirection === 'desc',
                onColumnClick: () => this.search(`deliveryEndDate-${getNextSort('deliveryEndDate')}`),
                onRender: orderQuote => (orderQuote.deliveryEndDate
                    ? this.time(orderQuote.deliveryEndDate, { locale }).getCleanDate({
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                    })
                    : ''),
            },
            {
                key: 'deliveryAddress.label',
                name: this.tKey('deliveryAddress'),
                fieldName: 'deliveryAddress.label',
                minWidth: 150,
                maxWidth: 250,
                isResizable: true,
                // eslint-disable-next-line react/no-unstable-nested-components
                onRender: order => (
                    <div className={styles['address-cell']}>
                        <b>{order['deliveryAddress.label'] || ''}</b>
                        <span>
                            {order['deliveryAddress.street'] || ''}
                        </span>
                        <span>
                            {order['deliveryAddress.zipCode'] || ''}
                            {' '}
                            {order['deliveryAddress.city'] || ''}
                            {' '}
                            {order['deliveryAddress.country.code'] || ''}
                        </span>
                    </div>
                ),
            },
            {
                key: 'status',
                name: this.tKey('status'),
                fieldName: 'status',
                minWidth: 140,
                maxWidth: 220,
                isResizable: true,
                className: styles['status-badge-container'],
                // eslint-disable-next-line react/no-unstable-nested-components
                onRender: row => {
                    const fullIndices = Object.keys(row)
                        .map(k => k.match(/workflowHistorics\.(\d+)\./)?.[1])
                    const indices = fullIndices
                        .filter((i, index, self) => i !== undefined && self.indexOf(i) === index)
                        .map(Number)
                    const acceptedHistoricIndex = indices.find(
                        i => row[`workflowHistorics.${i}.workflowStepId`] === 9,
                    )
                    const isAcceptedCompleted = acceptedHistoricIndex !== undefined
                        && row[`workflowHistorics.${acceptedHistoricIndex}.isCompleted`]
                    const refusedHistoricIndex = indices.find(
                        i => row[`workflowHistorics.${i}.workflowStepId`] === 8,
                    )
                    const isRefused = refusedHistoricIndex !== undefined
                        && (row[`workflowHistorics.${refusedHistoricIndex}.isActive`]
                            || row[`workflowHistorics.${refusedHistoricIndex}.isCompleted`])

                    if (isAcceptedCompleted)
                        return (
                            <span className={`${styles['status-badge']} ${styles['status-accepted']}`}>
                                {this.tKey('quoteStatusAcceptedSingular')}
                            </span>
                        )

                    if (isRefused)
                        return (
                            <span className={`${styles['status-badge']} ${styles['status-refused']}`}>
                                {this.tKey('quoteStatusRefusedSingular')}
                            </span>
                        )

                    const activeIndex = indices.find(
                        i => row[`workflowHistorics.${i}.isActive`] === true,
                    )

                    const stepId = activeIndex !== undefined
                        ? row[`workflowHistorics.${activeIndex}.workflowStepId`]
                        : null

                    return (
                        <span
                            className={classNames(styles['status-badge'], {
                                [styles['status-request']]: stepId === 5,
                                [styles['status-costing']]: stepId === 6,
                                [styles['status-client']]: stepId === 7,
                            })}
                        >
                            {{
                                5: this.tKey('requestForQuote'),
                                6: this.tKey('quoteStatusCreated'),
                                7: this.tKey('quoteStatusClientValidation'),
                            }[stepId] ?? ''}
                        </span>
                    )
                },

            },
        ]

        if ([EProfile.Admin, EProfile.SuperAdmin].includes(me.profileId)
            && isRefusedPage
        )
            cols.push({
                key: 'refuseReason',
                name: this.tKey('refusalReason'),
                minWidth: 200,
                maxWidth: 300,
                isResizable: true,
                className: styles['refuse-reason-cell'],
                // eslint-disable-next-line react/no-unstable-nested-components
                onRender: row => {
                    // récupération du motif (logique existante conservée)
                    let reason = row.refuseReason

                    if (!reason) {
                        const indices = Object.keys(row)
                            .map(k => k.match(/workflowHistorics\.(\d+)\./)?.[1])
                            .filter((v, i, a) => v !== undefined && a.indexOf(v) === i)
                            .map(Number)

                        const refusedIndex = indices.find(
                            i => row[`workflowHistorics.${i}.workflowStepId`] === 8,
                        )

                        reason = refusedIndex !== undefined
                            ? row[`workflowHistorics.${refusedIndex}.refuseReason`] || ''
                            : ''
                    }

                    if (!reason)
                        return null

                    return (
                        <TooltipHost
                            content={reason}
                            delay={TooltipDelay.medium}
                            directionalHint={DirectionalHint.bottomLeftEdge}
                        >
                            <span className={styles['truncate-text']}>
                                {reason}
                            </span>
                        </TooltipHost>
                    )
                },
            })

        // Date d’expiration : uniquement sur Validation client
        if (isClientValidationPage)
            cols.push({
                key: 'quoteExpirationDate',
                name: this.tKey('quoteExpirationDate'),
                minWidth: 120,
                maxWidth: 150,
                isResizable: true,
                className: styles['date-index-cell'],
                onRender: row => {
                    const raw = row.quoteExpirationDate
                        || row.expirationDate
                        || row.validUntil
                        || row.quoteValidUntil
                        || null

                    if (!raw)
                        return ''

                    // Normalisation : support string / number / Date
                    const date = raw instanceof Date ? raw : new Date(raw)

                    // Sécurité : si invalid => affichage vide (et pas de crash)
                    if (!this.isValidDate(date))
                        return ''

                    return this.time(date, { locale }).getCleanDate({
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                    })
                },
            })

        if ([EProfile.Admin, EProfile.SuperAdmin].includes(me.profileId))
            cols.splice(1, 0, {
                key: 'user.name',
                name: this.tKey('clientAccount'),
                fieldName: 'client.name',
                minWidth: 140,
                maxWidth: 160,
                isResizable: true,
                isSorted: sortedColumn === 'user.name',
                isSortedDescending: sortDirection === 'desc',
                onColumnClick: () => this.search(`user.name-${getNextSort('user.name')}`),
                // eslint-disable-next-line react/no-unstable-nested-components
                onRender: orderQuote => {
                    const firstname = orderQuote['createdByUser.firstname'] || ''
                    const lastname = orderQuote['createdByUser.lastname'] || ''
                    const email = orderQuote['createdByUser.email'] || ''
                    const phone = orderQuote['createdByUser.phoneNumber'] || ''

                    const hasUser = firstname || lastname || email || phone

                    return (
                        <div className={styles['address-cell']}>
                            {hasUser && (
                                <>
                                    <b>
                                        {firstname}
                                        {' '}
                                        {lastname}
                                    </b>
                                    {email && <span>{email}</span>}
                                    {phone && <span>{phone}</span>}
                                </>
                            )}
                        </div>
                    )
                },
            })

        if ([EProfile.Admin, EProfile.SuperAdmin].includes(me.profileId))
            cols.splice(1, 0, {
                key: 'client.name',
                name: this.tKey('client'),
                fieldName: 'client.name',
                minWidth: 80,
                maxWidth: 120,
                isResizable: true,
                className: styles['address-cell'],
                isSorted: sortedColumn === 'client.name',
                isSortedDescending: sortDirection === 'desc',
                onColumnClick: () => this.search(`client.name-${getNextSort('client.name')}`),
                // eslint-disable-next-line react/no-unstable-nested-components
                onRender: orderQuote => {
                    const clientName = orderQuote['client.name'] || '-'
                    return (
                        <div>
                            <b>{clientName}</b>
                        </div>
                    )
                },
            })

        // Status column is only relevant on the "all" tab, other tabs are already filtered on a single status
        this.setState({
            orderQuoteColumns: match?.params?.key === 'all' ? cols : cols.filter(col => col.key !== 'status'),
        })
    }

    /**
     * Setup breadcrumb elements
     */
    setupBreadcrumb() {
        const { setBreadcrumb } = this.props

        setBreadcrumb([
            { text: this.tKey('myOrderQuotes'), key: 'all-order', isCurrentItem: true },
        ])
    }

    /**
     * Setup commandbar elements
     */
    setupCommandBar() {
        const { setCommand, me: { profileId, client, company } } = this.props

        if (company.isOperational && [EProfile.CustomerAdmin, EProfile.CustomOrderEntry].includes(profileId) && client?.canCreateOrder)
            setCommand(
                [
                    {
                        key: 'new',
                        text: this.tKey('newOrderQuote'),
                        iconProps: { iconName: 'Add' },
                        onClick: () => {
                            history.push(`/order-quotes/${NEW_PATH}`)
                        },
                        className: 'is-bold',
                    },
                ],
            )
    }

    /**
     * Search order quote
     * @param {*} orderBy Sorting field used to order the results.
     */
    search(orderBy = undefined) {
        const { setMessageBar } = this.props
        const { searchParams } = this.state
        const nextOrderBy = orderBy ?? searchParams.orderBy
        setMessageBar({ isDisplayed: false })
        this.setState({
            status: Status.PENDING,
            searchParams: {
                ...searchParams,
                orderBy: nextOrderBy,
            },
        }, async () => {
            const { orderQuotesHandler, match } = this.props
            const { searchParams: nextSearchParams, pagination: { currentPage, recordsPerPage } } = this.state

            try {
                this.orderQuotesHandlerGetAll?.cancel()
                this.orderQuotesHandlerGetAll = orderQuotesHandler.getAllFromPage(
                    {
                        ...nextSearchParams,
                        orderBy: nextOrderBy,
                        orderByName: nextOrderBy,
                        page: match.params?.key,
                    },
                    currentPage,
                    recordsPerPage,
                )

                const res = await this.orderQuotesHandlerGetAll.fetch()
                this.setState({
                    items: res.items.map(x => this.flattenObj(x)),
                    pagination: {
                        currentPage: res.items.length === 0 ? 1 : currentPage,
                        totalPages: res.totalPages,
                        totalRecords: res.totalRecords,
                        recordsPerPage,
                    },
                    status: Status.RESOLVED,
                })
            } catch (error) {
                this.setState({ items: [], status: Status.REJECTED })
            }
        })
    }

    /**
     * Init Page
     */
    init() {
        const { setMessageBar, setCommand, me } = this.props

        setMessageBar({ isDisplayed: false })
        setCommand([])

        this.setColumns()

        this.setupBreadcrumb()
        this.setupCommandBar()

        if (!window.location.search) {
            this.syncSearchParamsInHistory()
            this.search()
        } else {
            const queryParams = new URLSearchParams(window.location.search)

            const timestamp = Date.parse(queryParams.get('creationDate'))
            const creationDateEndTimestamp = Date.parse(queryParams.get('creationDateEnd'))
            const pickupDateTimestamp = Date.parse(queryParams.get('pickupDate'))
            const pickupDateEndTimestamp = Date.parse(queryParams.get('pickupDateEnd'))
            const deliveryDateTimestamp = Date.parse(queryParams.get('deliveryDate'))
            const deliveryDateEndTimestamp = Date.parse(queryParams.get('deliveryDateEnd'))

            // Reset Filter
            this.setState({
                /** @type {SearchParamsType} */
                searchParams: {
                    orderStatusIds: queryParams.getAll('orderStatusIds') ? queryParams.getAll('orderStatusIds').map(x => +x) : [],
                    pickupAddressIds: me.clientId && queryParams.getAll('pickupAddressIds') ? queryParams.getAll('pickupAddressIds').map(x => +x) : [],
                    deliveryAddressIds: me.clientId && queryParams.getAll('deliveryAddressIds') ? queryParams.getAll('deliveryAddressIds').map(x => +x) : [],
                    pickupAddress: !me.clientId ? queryParams.get('pickupAddress') || '' : '',
                    deliveryAddress: !me.clientId ? queryParams.get('deliveryAddress') || '' : '',
                    creationDate: !Number.isNaN(timestamp) ? new Date(timestamp) : null,
                    creationDateEnd: !Number.isNaN(creationDateEndTimestamp) ? new Date(creationDateEndTimestamp) : null,
                    deliveryDate: !Number.isNaN(deliveryDateTimestamp) ? new Date(deliveryDateTimestamp) : null,
                    deliveryDateEnd: !Number.isNaN(deliveryDateEndTimestamp) ? new Date(deliveryDateEndTimestamp) : null,
                    pickupDate: !Number.isNaN(pickupDateTimestamp) ? new Date(pickupDateTimestamp) : null,
                    pickupDateEnd: !Number.isNaN(pickupDateEndTimestamp) ? new Date(pickupDateEndTimestamp) : null,
                    // orderId: queryParams.get('orderId') ? queryParams.get('orderId') : null,
                    orderQuoteNumber: queryParams.get('orderQuoteNumber') || null,
                    workflowStepIds: (queryParams.getAll('workflowStepIds') || []).map(x => +x),
                    clientId: queryParams.get('clientId') ? +queryParams.get('clientId') : null,
                    operatingCenterId: queryParams.get('operatingCenterId') ? +queryParams.get('operatingCenterId') : null,
                    orderBy: queryParams.get('orderBy') ? queryParams.get('orderBy') : null,
                },
            }, () => {
                this.syncSearchParamsInHistory()
                this.search()
            })
        }
    }

    /**
     * Sync SearchParams in navigation history
     */
    syncSearchParamsInHistory() {
        const { searchParams } = this.state

        const queryParams = new URLSearchParams(window.location.search)

        // eslint-disable-next-line no-restricted-syntax
        for (const key in searchParams)
            if (searchParams[key] !== null && searchParams[key] !== '' && searchParams[key]?.length !== 0)
                if (Array.isArray(searchParams[key]))
                    // eslint-disable-next-line no-restricted-syntax
                    for (const element of searchParams[key])
                        queryParams.append(key, element)
                else
                    queryParams.set(key, searchParams[key])
            else
                queryParams.delete(key)

        history.replace({
            search: queryParams.toString(),
        })
    }

    /**
     * Export elements
     */
    // eslint-disable-next-line react/no-unused-class-component-methods
    export() {
        this.setState({
            status: Status.PENDING,
        }, async () => {
            const { orderQuotesHandler, match, lang } = this.props
            const { searchParams } = this.state
            try {
                this.orderQuotesHandlerExportAll = orderQuotesHandler.exportAll({
                    ...searchParams,
                    page: match.params?.key,
                    lang,
                })
                const { fileName, blob } = await this.orderQuotesHandlerExportAll.fetch()
                HandleBlob.download(blob, fileName)
                this.setState({ status: Status.RESOLVED })
            } catch (error) {
                switch (error?.constructor) {
                    case CancelRequestError:
                    case UnauthorizedError:
                    case InvalidEntityError:
                    case NotImplementedError:
                    default:
                        this.setState({ status: Status.REJECTED })
                        // eslint-disable-next-line no-console
                        console.error(error)
                        break
                }
            }
        })
    }

    /**
     * Render component
     * @returns {JSX.Element} Element
     */
    render() {
        const {
            status, items, searchParams, orderQuoteColumns, isFilterCardReduced, pagination,
        } = this.state

        const {
            lang, param, me, match,
        } = this.props
        const orderedKeys = [5, 6, 7, 9, 8]
        const workflowStepKeyMap = {
            5: 'requestForQuote',
            6: 'quoteStatusCreated',
            7: 'quoteStatusClientValidation',
            9: 'quoteStatusAccepted',
            8: 'quoteStatusRefused',
        }

        if (!me.company.isOperational)
            return (<MaintenancePortalInfo lang={lang} />)
        return (
            <main className={styles.index}>
                <Card
                    title={this.tKey('filters')}
                    iconName="FilterSettings"
                    headerComponent={(
                        <button
                            type="button"
                            onClick={() => this.setState({ isFilterCardReduced: !isFilterCardReduced })}
                            className={styles['reduce-button-container']}
                        >
                            <div className={styles['reduce-button']}>
                                <Text>
                                    {isFilterCardReduced ? this.tKey('reduce') : this.tKey('extend')}
                                </Text>
                                <Text>
                                    <Icon iconName={isFilterCardReduced ? 'ChevronUp' : 'ChevronDown'} />
                                </Text>
                            </div>
                        </button>
                    )}
                >
                    {isFilterCardReduced && (
                        <form
                            onSubmit={ev => {
                                ev.preventDefault()
                                this.search()
                            }}
                        >
                            <Columns>
                                {/* Partie gauche : 75% */}
                                <Columns.Column size="three-quarters">
                                    {/* Première ligne */}
                                    <Columns>
                                        <Columns.Column size="one-quarter">
                                            <TextField
                                                label={this.tKey('orderQuoteNumber')}
                                                placeholder={this.tKey('search')}
                                                disabled={status === Status.PENDING}
                                                value={searchParams.orderQuoteNumber || ''}
                                                onChange={(ev, newVal) => this.setState({ searchParams: { ...searchParams, orderQuoteNumber: newVal } })}
                                            />
                                        </Columns.Column>
                                        {/* {!me.isClient && (
                                            <Columns.Column size="one-quarter">
                                                <FilteredVirtualCombobox
                                                    label={this.tKey('client')}
                                                    placeholder={this.tKey('select')}
                                                    options={param.clients.reduce((acc, { key, text }) => {
                                                        if (me.clientIds.length && !me.clientIds.includes(+key))
                                                            return acc
                                                        return [...acc, { key, text: this.tObj(this.parseJson(text)) }]
                                                    }, [])}
                                                    selectedKey={searchParams.clientId}
                                                    disabled={status === Status.PENDING}
                                                    onChange={(_ev, option) => this.setState({
                                                        searchParams: { ...searchParams, clientId: option.key },
                                                    })}
                                                />
                                            </Columns.Column>
                                        )} */}
                                        <Columns.Column size="one-quarter">
                                            {me.clientId ? (
                                                <FilteredVirtualCombobox
                                                    label={this.tKey('pickupAddress')}
                                                    placeholder={this.tKey('select')}
                                                    options={param.addresses.filter(x => x.isVisible).map(({ key, text }) => ({
                                                        key,
                                                        text: this.tObj(this.parseJson(text)),
                                                    }))}
                                                    selectedKey={searchParams.pickupAddressIds}
                                                    disabled={status === Status.PENDING}
                                                    onChange={(_ev, option) => this.setState({
                                                        searchParams: {
                                                            ...searchParams,
                                                            pickupAddress: '',
                                                            pickupAddressIds: this.getUpdatedList(searchParams.pickupAddressIds, option),
                                                        },
                                                    })}
                                                    multiSelect
                                                />
                                            ) : (
                                                <TextField
                                                    label={this.tKey('pickupAddress')}
                                                    placeholder={this.tKey('pickupAddress')}
                                                    value={searchParams.pickupAddress}
                                                    disabled={status === Status.PENDING}
                                                    onChange={(ev, newVal) => this.setState({
                                                        searchParams: {
                                                            ...searchParams,
                                                            pickupAddress: newVal,
                                                            pickupAddressIds: [],
                                                        },
                                                    })}
                                                />
                                            )}
                                        </Columns.Column>
                                        <Columns.Column size="one-quarter">
                                            {me.clientId ? (
                                                <FilteredVirtualCombobox
                                                    label={this.tKey('deliveryAddress')}
                                                    placeholder={this.tKey('select')}
                                                    options={param.addresses.filter(x => x.isVisible).map(({ key, text }) => ({
                                                        key,
                                                        text: this.tObj(this.parseJson(text)),
                                                    }))}
                                                    selectedKey={searchParams.deliveryAddressIds}
                                                    disabled={status === Status.PENDING}
                                                    onChange={(_ev, option) => this.setState({
                                                        searchParams: {
                                                            ...searchParams,
                                                            deliveryAddress: '',
                                                            deliveryAddressIds: this.getUpdatedList(searchParams.deliveryAddressIds, option),
                                                        },
                                                    })}
                                                    multiSelect
                                                />
                                            ) : (
                                                <TextField
                                                    label={this.tKey('deliveryAddress')}
                                                    placeholder={this.tKey('deliveryAddress')}
                                                    value={searchParams.deliveryAddress}
                                                    disabled={status === Status.PENDING}
                                                    onChange={(ev, newVal) => this.setState({
                                                        searchParams: {
                                                            ...searchParams,
                                                            deliveryAddress: newVal,
                                                            deliveryAddressIds: [],
                                                        },
                                                    })}
                                                />
                                            )}
                                        </Columns.Column>
                                        <Columns.Column size="one-quarter">
                                            {!me.isClient && (
                                                <FilteredVirtualCombobox
                                                    label={this.tKey('client')}
                                                    placeholder={this.tKey('select')}
                                                    options={param.clients.reduce((acc, { key, text }) => {
                                                        if (me.clientIds.length && !me.clientIds.includes(+key))
                                                            return acc
                                                        return [...acc, { key, text: this.tObj(this.parseJson(text)) }]
                                                    }, [])}
                                                    selectedKey={searchParams.clientId}
                                                    disabled={status === Status.PENDING}
                                                    onChange={(_ev, option) => this.setState({
                                                        searchParams: { ...searchParams, clientId: option.key },
                                                    })}
                                                />
                                            )}

                                        </Columns.Column>

                                    </Columns>

                                    {/* Deuxième ligne */}
                                    <Columns>
                                        {/* {['all'].includes(match.params?.key) && (
                                            <Columns.Column size="one-quarter">
                                                <FilteredVirtualCombobox
                                                    label={this.tKey('status')}
                                                    placeholder={this.tKey('select')}
                                                    options={(param.workflowSteps ?? [])
                                                        .filter(({ key }) => orderedKeys.includes(Number(key)))
                                                        // masqer demande devis pour admin
                                                        .filter(
                                                            ({ key }) => !(
                                                                [EProfile.Admin, EProfile.SuperAdmin].includes(me.profileId)
                                                                && Number(key) === 5
                                                            ),
                                                        )
                                                        .sort(
                                                            (a, b) => orderedKeys.indexOf(Number(a.key))
                                                                - orderedKeys.indexOf(Number(b.key)),
                                                        ).map(({ key }) => {
                                                            const stepId = Number(key)
                                                            const translationKey = workflowStepKeyMap[stepId]
                                                            return {
                                                                key,
                                                                text: translationKey ? this.tKey(translationKey) : key,
                                                            }
                                                        })}
                                                    // selectedKey={searchParams.workflowStepIds[0] ?? null}
                                                    selectedKeys={searchParams.workflowStepIds}
                                                    disabled={status === Status.PENDING}
                                                    onChange={(_ev, option) => {
                                                        const newList = this.getUpdatedList(searchParams.workflowStepIds, option)
                                                        this.setState({
                                                            searchParams: { ...searchParams, workflowStepIds: newList },
                                                        })
                                                    }}
                                                    multiSelect
                                                />
                                            </Columns.Column>
                                        )} */}
                                        <Columns.Column size="one-quarter">
                                            <div className={styles['date-filter']}>

                                                <DatePicker
                                                    label={this.tKey('creationDate')}
                                                    date={searchParams.creationDate}
                                                    minDate={DateFilterMinDate}
                                                    maxDate={DateFilterMaxDate}
                                                    lang={lang}
                                                    onChangeDate={date => {
                                                        this.setState({
                                                            searchParams: {
                                                                ...searchParams,
                                                                creationDate: this.isValidDate(date) ? date : null,
                                                            },
                                                        })
                                                    }}
                                                />
                                                <DatePicker
                                                    disabled={!searchParams.creationDate}
                                                    date={searchParams.creationDateEnd}
                                                    minDate={searchParams.creationDate || DateFilterMinDate}
                                                    maxDate={DateFilterMaxDate}
                                                    lang={lang}
                                                    onChangeDate={date => {
                                                        this.setState({
                                                            searchParams: {
                                                                ...searchParams,
                                                                creationDateEnd: this.isValidDate(date) ? date : null,
                                                            },
                                                        })
                                                    }}
                                                />
                                            </div>
                                        </Columns.Column>
                                        <Columns.Column size="one-quarter">
                                            <div className={styles['date-filter']}>
                                                <DatePicker
                                                    label={this.tKey('pickupDate')}
                                                    date={searchParams.pickupDate}
                                                    minDate={DateFilterMinDate}
                                                    maxDate={DateFilterMaxDate}
                                                    lang={lang}
                                                    onChangeDate={date => {
                                                        this.setState({
                                                            searchParams: {
                                                                ...searchParams,
                                                                pickupDate: this.isValidDate(date) ? date : null,
                                                            },
                                                        })
                                                    }}
                                                />
                                                <DatePicker
                                                    disabled={!searchParams.pickupDate}
                                                    date={searchParams.pickupDateEnd}
                                                    minDate={searchParams.pickupDate || DateFilterMinDate}
                                                    maxDate={DateFilterMaxDate}
                                                    lang={lang}
                                                    onChangeDate={date => {
                                                        this.setState({
                                                            searchParams: {
                                                                ...searchParams,
                                                                pickupDateEnd: this.isValidDate(date) ? date : null,
                                                            },
                                                        })
                                                    }}
                                                />
                                            </div>
                                        </Columns.Column>
                                        <Columns.Column size="one-quarter">
                                            <div className={styles['date-filter']}>

                                                <DatePicker
                                                    label={this.tKey('deliveryDate')}
                                                    date={searchParams.deliveryDate}
                                                    minDate={DateFilterMinDate}
                                                    maxDate={DateFilterMaxDate}
                                                    lang={lang}
                                                    onChangeDate={date => {
                                                        this.setState({
                                                            searchParams: {
                                                                ...searchParams,
                                                                deliveryDate: this.isValidDate(date) ? date : null,
                                                            },
                                                        })
                                                    }}
                                                />
                                                <DatePicker
                                                    disabled={!searchParams.deliveryDate}
                                                    date={searchParams.deliveryDateEnd}
                                                    minDate={searchParams.deliveryDate || DateFilterMinDate}
                                                    maxDate={DateFilterMaxDate}
                                                    lang={lang}
                                                    onChangeDate={date => {
                                                        this.setState({
                                                            searchParams: {
                                                                ...searchParams,
                                                                deliveryDateEnd: this.isValidDate(date) ? date : null,
                                                            },
                                                        })
                                                    }}
                                                />
                                            </div>
                                        </Columns.Column>
                                        <Columns.Column size="one-quarter">
                                            {['all'].includes(match.params?.key) && (
                                                <FilteredVirtualCombobox
                                                    label={this.tKey('status')}
                                                    placeholder={this.tKey('select')}
                                                    options={(param.workflowSteps ?? [])
                                                        .filter(({ key }) => orderedKeys.includes(Number(key)))
                                                        // eslint-disable-next-line max-len
                                                        .filter(({ key }) => !([EProfile.Admin, EProfile.SuperAdmin].includes(me.profileId) && Number(key) === 5))
                                                        .sort((a, b) => orderedKeys.indexOf(Number(a.key)) - orderedKeys.indexOf(Number(b.key)))
                                                        .map(({ key }) => {
                                                            const stepId = Number(key)
                                                            const translationKey = workflowStepKeyMap[stepId]
                                                            return {
                                                                key,
                                                                text: translationKey ? this.tKey(translationKey) : key,
                                                            }
                                                        })}
                                                    selectedKeys={searchParams.workflowStepIds}
                                                    disabled={status === Status.PENDING}
                                                    onChange={(_ev, option) => {
                                                        const newList = this.getUpdatedList(searchParams.workflowStepIds, option)
                                                        this.setState({
                                                            searchParams: { ...searchParams, workflowStepIds: newList },
                                                        })
                                                    }}
                                                    multiSelect
                                                />
                                            )}
                                        </Columns.Column>
                                    </Columns>
                                </Columns.Column>
                                {/* {!me.isClient && (
                                            <Columns.Column size="three-quarters">
                                                <Columns>
                                                    <Columns.Column size="one-third">
                                                        <FilteredVirtualCombobox
                                                            label={this.tKey('operatingCenter')}
                                                            options={param.operatingCenters.reduce((acc, { key, text }) => {
                                                                if (me.operatingCenterIds.length && !me.operatingCenterIds.includes(+key))
                                                                    return acc
                                                                return [...acc, { key, text: this.tObj(this.parseJson(text)) }]
                                                            }, [])}
                                                            selectedKey={searchParams.operatingCenterId}
                                                            disabled={status === Status.PENDING}
                                                            onChange={(_ev, option) => this.setState({
                                                                searchParams: { ...searchParams, operatingCenterId: option.key },
                                                            })}
                                                        />
                                                    </Columns.Column>
                                                </Columns>
                                            </Columns.Column>
                                        )} */}
                                {/* Partie droite : 25% */}
                                <Columns.Column size="one-quarter">
                                    <div
                                        className={styles['action-filter-buttons']}
                                    >
                                        <div>
                                            <DefaultButton
                                                text={this.tKey('research')}
                                                primary
                                                split
                                                disabled={status === Status.PENDING}
                                                onClick={() => this.submitInput.current.click()}
                                                iconProps={{ iconName: 'Search' }}
                                                menuProps={{
                                                    items: [
                                                        {
                                                            key: 'Search',
                                                            text: this.tKey('research'),
                                                            iconProps: { iconName: 'Search' },
                                                            onClick: () => this.submitInput.current.click(),
                                                        },
                                                        ...([EProfile.Admin, EProfile.SuperAdmin].includes(me.profileId)
                                                            ? [{
                                                                key: 'Export',
                                                                text: this.tKey('export'),
                                                                iconProps: { iconName: 'Export' },
                                                                onClick: () => this.export(),
                                                            }]
                                                            : []
                                                        ),
                                                    ],
                                                }}
                                            />
                                        </div>
                                        <div className={styles.separator} />
                                        <div>
                                            <TooltipHost
                                                content={this.tKey('resetFilters')}
                                                directionalHint={DirectionalHint.topAutoEdge}
                                                delay={TooltipDelay.medium}
                                                componentRef={this.toolTipRef}
                                            >
                                                <DefaultButton
                                                    disabled={status === Status.PENDING}
                                                    styles={{
                                                        root: {
                                                            minWidth: '40px',
                                                            maxWidth: '40px',
                                                        },
                                                    }}
                                                    iconProps={{ iconName: 'ClearFilter' }}
                                                    onClick={() => this.setState(
                                                        {
                                                            /** @type {SearchParamsType} */
                                                            searchParams: {
                                                                orderStatusIds: [],
                                                                pickupAddressIds: [],
                                                                deliveryAddressIds: [],
                                                                pickupAddress: '',
                                                                deliveryAddress: '',
                                                                creationDate: null,
                                                                creationDateEnd: null,
                                                                deliveryDate: null,
                                                                deliveryDateEnd: null,
                                                                pickupDate: null,
                                                                pickupDateEnd: null,
                                                                orderQuoteNumber: null,
                                                                workflowStepIds: [],
                                                                clientId: null,
                                                                operatingCenterId: null,
                                                                orderBy: null,
                                                            },
                                                            pagination: {
                                                                ...pagination,
                                                                currentPage: 1,
                                                            },
                                                        },
                                                        () => this.search(),
                                                    )}
                                                />
                                            </TooltipHost>
                                        </div>
                                    </div>
                                </Columns.Column>
                            </Columns>
                            {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                            <button
                                type="submit"
                                style={{ display: 'none' }}
                                ref={this.submitInput}
                                tabIndex={-1}
                            />
                        </form>
                    )}
                </Card>
                <br />
                <Card>
                    <ShimmeredDetailsList
                        items={items}
                        columns={orderQuoteColumns}
                        selectionMode={SelectionMode.none}
                        onShouldVirtualize={() => true}
                        enableShimmer={status === Status.PENDING}
                        layoutMode={DetailsListLayoutMode.justified}
                        constrainMode={ConstrainMode.unconstrained}
                        onRenderDetailsHeader={(props, defaultRender) => defaultRender({ ...props, styles: { root: { paddingTop: 0 } } })}
                        // eslint-disable-next-line react/no-unstable-nested-components
                        onRenderRow={(props, defaultRender) => (
                            <Link to={`/order-quotes/${props.item?.orderQuoteId}`}>
                                {defaultRender(props)}
                            </Link>
                        )}
                    />
                    {!items?.length && [Status.RESOLVED, Status.REJECTED].includes(status)
                        && <Text styles={{ root: { fontStyle: 'italic', marginLeft: '1em' } }}>{this.tKey('noResultFound')}</Text>}
                </Card>
                {/* <ContentResponsive min={768}>
                    <OrderQuoteList
                        lang={lang}
                        orders={items}
                        status={status}
                        isMoussetUser={!me.isClient}
                        onOrderQuoteByChange={orderBy => this.search(orderBy)}
                    />
                </ContentResponsive> */}
                {/* <ContentResponsive max={768}>
                    <OrderQuoteCardList
                        lang={lang}
                        orders={items}
                        status={status}
                    />
                </ContentResponsive> */}
                {/* {!!me.client && (
                    <ChooseOrderQuoteType
                        isOrderQuoteModalOpen={isOrderQuoteModalOpen}
                        orderTypes={me.client.orderTypes}
                        lang={lang}
                        cancel={() => this.setState({ isOrderQuoteModalOpen: false })}
                    />
                )} */}
                <Pagination
                    data={pagination || {
                        currentPage: 1, totalPages: 1, totalRecords: 0, recordsPerPage: 20,
                    }}
                    lang={lang}
                    onPageChange={page => this.setState(
                        { pagination: { ...(pagination || {}), currentPage: page } },
                        () => this.search(),
                    )}
                    itemName="orderQuote"
                />

            </main>
        )
    }
}

IndexOrderQuotes.prototype.handleRenderColumn = handleRenderColumn
IndexOrderQuotes.prototype.time = time
IndexOrderQuotes.prototype.isValidDate = isValidDate
IndexOrderQuotes.prototype.parseJson = parseJson
IndexOrderQuotes.prototype.getUpdatedList = getUpdatedList
IndexOrderQuotes.prototype.flattenObj = flattenObj
IndexOrderQuotes.prototype.tKey = tKey
IndexOrderQuotes.prototype.tObj = tObj
